import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

import GLightbox from 'glightbox';

(function (Drupal) {
  Drupal.behaviors.splideInit = {
    attach(context) {
      const splides = context.querySelectorAll('.splide:not(.splide-initialized)');

      const configs = {
        movil: {
          type: 'slide',
          arrows: true,
          pagination: false,
          trimSpace: false,
          focus: 'center',
          gap: '56px',
          breakpoints: {
            992: { perPage: 1.4, gap: '24px' },
            768: { perPage: 1.2, gap: '0' },
          },
        },
        galeria: {
          type: 'slide',
          arrows: true,
          pagination: false,
          trimSpace: true,
          focus: 'center',
          gap: '32px',
          perPage: 3.5,
          perMove: 3,
          breakpoints: {
            992: { perPage: 1.4, gap: '32px' },
            768: { perPage: 1.2, gap: '24px' },
          },
        },
        viewOne: {
          type: 'slide',
          arrows: true,
          pagination: false,
          perPage: 1,
          rewind: true,
          trimSpace: false,
          gap: '24px',
        },
        tags: {
          type: 'slide',
          arrows: false,
          pagination: false,
          perPage: 2.3,
          focus: 0,
          trimSpace: true,
          flickPower: 200,
          drag: 'free',
          releaseWheel: true,
          breakpoints: {
            992: { perPage: 1.8, gap: '8px' },
            768: { perPage: 1.4, gap: '4px' },
          },
        },
      };
      // Devuelve el índice del slide con el radio activo
      function getCheckedIndex(el, splide) {
        const checkedSlide = el
          .querySelector('.splide__slide input[type="radio"]:checked')
          ?.closest('.splide__slide');
        if (!checkedSlide) return null;

        // Antes de montar Splide aún no hay componentes, así que usamos una alternativa
        const slides = splide
          ? splide.Components.Slides.get().map(s => s.slide)
          : Array.from(el.querySelectorAll('.splide__list > .splide__slide'));

        const idx = slides.indexOf(checkedSlide);
        return idx >= 0 ? idx : null;
      }
      // --- Pausar todos los vídeos (YouTube, Vimeo o HTML5)
      function stopAllRemoteVideos(container) {
        // Pausar <video> HTML5
        container.querySelectorAll('video').forEach((v) => {
          try {
            v.pause();
            v.currentTime = 0;
          } catch {}
        });

        // Reiniciar iframes (YouTube / Vimeo)
        container.querySelectorAll('iframe').forEach((iframe) => {
          const src = iframe.getAttribute('src');
          if (src && (src.includes('youtube.com') || src.includes('vimeo.com'))) {
            iframe.setAttribute('src', src); // recarga → detiene vídeo
          }
        });
      }

      // --- Inicializador genérico
      const initSplide = (el, options, mobileOnly = false) => {
        let splide = null;

        const enable = () => {
          if (!splide) {
            let extra = {};
            if (el.classList.contains('splide--tags')) {
              const preIndex = getCheckedIndex(el, null);
              if (preIndex != null) extra.start = preIndex;
            }

            splide = new Splide(el, { ...options, ...extra });

            splide.on('mounted', () => {
              el.style.visibility = 'visible';
              el.classList.add('splide-initialized');

              // Recalcular AOS al inicializar
              if (typeof AOS !== 'undefined' && typeof AOS.refreshHard === 'function') {
                AOS.refreshHard();
              }

              // Ocultar flechas si solo hay un slide
              const arrows = el.querySelector('.splide__arrows');
              if (arrows && splide.length <= 1) {
                arrows.style.display = 'none';
              }
            });

            // Pausar vídeos al cambiar de slide
            splide.on('moved', () => {
              stopAllRemoteVideos(el);

              if (typeof AOS !== 'undefined' && typeof AOS.refreshHard === 'function') {
                AOS.refreshHard();
              }
            });

            splide.mount();

            if (el.classList.contains('splide--tags')) {
              el.addEventListener('change', (e) => {
                if (e.target.matches('input[type="radio"]') && e.target.checked) {
                  requestAnimationFrame(() => {
                    const idx = getCheckedIndex(el, splide);
                    if (idx == null) return;

                    const len = splide.length;
                    const perPage = Math.max(1, Math.ceil(splide.options.perPage || 1));
                    const lastReachable = Math.max(0, len - perPage);

                    // Desplaza el carrusel para que el radio activo se vea completo
                    splide.go(Math.min(idx, lastReachable));
                  });
                }
              });
            }
          }

          el.classList.remove('is-desktop');
        };

        const disable = () => {
          if (splide) {
            splide.destroy();
            splide = null;
          }
          el.classList.add('is-desktop');
        };

        const check = () => {
          if (mobileOnly) {
            window.innerWidth < 992 ? enable() : disable();
          } else {
            enable();
          }
        };

        check();
        window.addEventListener('resize', check);
      };

      // --- Inicializar todos los sliders
      splides.forEach((el) => {
        if (el.classList.contains('splide--galeria')) {
          initSplide(el, configs.galeria);
        } else if (el.classList.contains('splide--movil')) {
          initSplide(el, configs.movil, true);
        } else if (el.classList.contains('splide--viewOne')) {
          initSplide(el, configs.viewOne);
        } else if (el.classList.contains('splide--tags')) {
          initSplide(el, configs.tags, true);
        }
      });

      // --- Detectar cuando un modal .modal-video se oculta → detener vídeo
      const modals = document.querySelectorAll('.modal');

      modals.forEach((modal) => {
        let wasVisible = modal.classList.contains('show');

        // Observar cambios de clase o estilo
        const observer = new MutationObserver(() => {
          const isVisible = modal.classList.contains('show');
          const display = window.getComputedStyle(modal).display;

          // Si antes estaba visible y ahora no, el modal se cerró
          if (wasVisible && (!isVisible || display === 'none')) {
            stopAllRemoteVideos(modal);
          }

          wasVisible = isVisible;
        });

        observer.observe(modal, {
          attributes: true,
          attributeFilter: ['class', 'style', 'aria-hidden'],
        });
      });

      // --- Inicializar GLightbox (solo una vez por página)
      //
      // GLightbox se engancha al documento entero por selector, así que no
      // depende del contexto de attach. El contexto sí varía: en la carga
      // inicial Drupal pasa `document` (que no tiene classList) y en cada
      // respuesta AJAX pasa el fragmento sustituido, de modo que marcar el
      // propio contexto no servía como guarda. once() lleva su propio
      // registro sobre <body> y cubre los dos casos.
      once('glightbox', 'body').forEach(() => {
        GLightbox({
          selector: '.glightbox',
          touchNavigation: true,
          loop: true,
          zoomable: true,
          autoplayVideos: false,
        });
      });
    },
  };
})(Drupal);
